import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { valURL } from "../../utils/ValidationFunctions";
import ErrorBanner from "./ErrorBanner";

type Props = {
  handler: (value: Array<{ name: string; url: string }>) => void;

  id: string;
  value?: Array<{ name: string; url: string }>;
  name: string;
  style_class?: string;
  label_class?: string;
  add_button_class?: string;
  list_class?: string;
  wrap_class?: string;
};

const LinkFieldInput: React.FC<Props> = ({
  handler,
  value,
  id,
  name,
  style_class,
  add_button_class,
  list_class,
  wrap_class,
}) => {
  const { t } = useTranslation();

  const [curLinkName, setCurLinkName] = useState("");
  const [curLinkUrl, setCurLinkUrl] = useState("");
  const [links, setLinks] = useState<Array<{ name: string; url: string }>>([]);

  useEffect(() => {
    if (value) {
      setLinks([...value]);
    }
  }, [value]);

  const addElement = () => {
    if (valURL(curLinkUrl)) {
      const curLinks = [...links];
      curLinks.push({ name: curLinkName, url: curLinkUrl });
      setCurLinkName("");
      setCurLinkUrl("");
      setLinks(curLinks);

      handler(curLinks);
    }
  };

  const removeElement = (index: number) => {
    const curLinks = [...links];
    curLinks.splice(index, 1);
    setLinks(curLinks);

    handler(curLinks);
  };

  return (
    <div className={wrap_class}>
      {links.length > 0 ? (
        <ul>
          <li className={list_class}>確定済みリンク</li>
          {links.map((el, i) => {
            return (
              <li key={i} className={list_class}>
                <a href={el.url} target="_blank" rel="noopener noreferrer">
                  {el.name}
                </a>
                <button type="button" onClick={() => removeElement(i)} />
              </li>
            );
          })}
        </ul>
      ) : null}
      <div className={style_class}>
        <label htmlFor={`${name}_nameField`}>{t("タイトル")}</label>
        <input
          type="text"
          id={`${name}_nameField`}
          name={`${name}_name`}
          onChange={(event) => {
            setCurLinkName(event.target.value);
          }}
          value={curLinkName}
          list={`${id}-list`}
        />
        <ErrorBanner
          warn={curLinkUrl && !valURL(curLinkUrl) ? true : false}
          message={t("error.url")}
        />
        <label htmlFor={`${name}_urlField`}>{t("URL")}</label>
        <input
          type="text"
          id={`${name}_urlField`}
          name={`${name}_url`}
          onChange={(event) => {
            setCurLinkUrl(event.target.value);
          }}
          value={curLinkUrl}
          list={`${id}-list`}
        />

        <button
          type="button"
          onClick={addElement}
          className={add_button_class}
        />
      </div>
    </div>
  );
};

export default LinkFieldInput;
